import { useSelector } from 'react-redux'
import { usersSelector } from 'src/state/selectors'
import Setting from '../../Setting'

export default function BasicInfo() {
  const { user } = useSelector(usersSelector)
  const { username, email, city } = user || {}

  return (
    <Setting
      title="Informații de Bază"
      rightButton={null}
      iconPath="/icons/id-card.png"
      body={
        <div className="info-content">
          {username && (
            <div className="info-row">
              <strong>Username:</strong> {username}
            </div>
          )}
          {city && (
            <div className="info-row">
              <strong>Oraș:</strong> {city}
            </div>
          )}
          {email && (
            <div className="info-row">
              <strong>Email:</strong> {email}
            </div>
          )}
        </div>
      }
      alwaysShowsBody
      infoText={
        <>
          Pentru a schimba aceste informații, te rugăm să <a href="/contact">ne contactezi</a>.
        </>
      }
    />
  )
}
